@if (categories$ | async; as categories) {
    <div
        [tabIndex]="0"
        class="d-inline"
        #divCategories
        [attr.aria-label]="
            categoryName && categoryCount
                ? ('productList.subCategory.arialLabel' | cxTranslate: { name: categoryName, count: categoryCount })
                : null
        ">
        @for (subCategory of categories; track subCategory.code) {
            <a
                #popover="ngbPopover"
                [tabindex]="0"
                role="button"
                class="btn-facet btn-sm category cursor-pointer"
                [ngbPopover]="subcategories"
                [popoverContext]="{ query: generateCategoryQuery(subCategory), parent: subCategory }"
                (click)="
                    openCategoryFacet(
                        subCategory.query.query.value,
                       parentCategoryId,
                        subCategory.name,
                        subCategory.count,
                        divCategories
                    )
                "
                (mouseover)="openPopup(popover)"
                (mouseout)="clearPopupTimeout(popover)"
                [disablePopover]="lowestLevelSelected"
                popoverClass="popover-default facet-subcategories-popover"
                placement="bottom"
                container="body"
                [ngClass]="{ selected: subCategory.selected }"
                [attr.aria-label]="
                    'productList.subCategory.arialLabel'
                        | cxTranslate: { name: subCategory.name, count: subCategory.count }
                ">
                {{ subCategory.name }}
                <span class="amount">{{ subCategory.count }}</span>
            </a>
        }
        @if (showToggle(allValues.length)) {
            <a class="btn-facet btn-sm category show-all" (click)="toggleShowAll()">
                <i
                    class="aimo-icon icon-sm icon-inline"
                    [ngClass]="showAllValues ? 'icon-minus-bold' : 'icon-plus-bold'"></i>
                <span>{{
                        (showAllValues ? 'aimo.product.hideCategories' : 'aimo.product.showCategories') | cxTranslate
                    }}</span>
            </a>
        }
    </div>

    <ng-template #subcategories let-query="query" let-parent="parent">
        @if (getCategory(query) | async; as subCategories) {
            <div class="subcategories_wrapper">
                <ul class="subcategories">
                    @for (subCategory of subCategories; track subCategory.code) {
                        <li>
                            <a
                                [tabindex]="0"
                                role="button"
                                (click)="
                                    openCategoryFacet(
                                        subCategory.query.query.value,
                                        parent.code,
                                        parent.name,
                                        subCategory.count,
                                        divCategories
                                    )
                                "
                                class="btn-facet btn-sm category cursor-pointer"
                                [ngClass]="{ selected: subCategory.selected }"
                                [attr.aria-label]="
                                    'productList.subCategory.arialLabel'
                                        | cxTranslate: { name: subCategory.name, count: subCategory.count }
                                ">
                                {{ subCategory.name }}
                                <span class="amount">{{ subCategory.count }}</span>
                            </a>
                        </li>
                    }
                </ul>
            </div>
        }
    </ng-template>
}
